import { render, staticRenderFns } from "./Citizenship.vue?vue&type=template&id=06595c68&scoped=true"
import script from "./Citizenship.vue?vue&type=script&lang=js"
export * from "./Citizenship.vue?vue&type=script&lang=js"
import style0 from "./Citizenship.vue?vue&type=style&index=0&id=06595c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06595c68",
  null
  
)

export default component.exports